import { render, staticRenderFns } from "./NotifViewer.vue?vue&type=template&id=b537d732&scoped=true&"
import script from "./NotifViewer.vue?vue&type=script&lang=ts&"
export * from "./NotifViewer.vue?vue&type=script&lang=ts&"
import style0 from "./NotifViewer.vue?vue&type=style&index=0&id=b537d732&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b537d732",
  null
  
)

export default component.exports